/* eslint-disable react/no-danger -- Markdown*/
/** @typedef	{import("./Types/BlogsCardProps").default} Props */

import { date } from '@mooveguru/js-utilities';
import { translate } from '../../Internationalization';
import React from 'react';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
export default function BlogCard(props) {
	function body() {
		return (
			<div>
				<img
					alt={props.title}
					className="card-image"
					src={props.imageUrl}
				/>

				<div className="flex flex-col flex-grow border rounded rounded-t-none border-t-0 border-grey-300">
					<div className="flex-grow p-4">
						<h2
							className="hl-ms-4 mb-4 text-black"
							dangerouslySetInnerHTML={{
								__html: props.title,
							}}
						/>

						<p className="font-thin text-grey-500 mb-4">
							{date.convertDateToDateString(props.date)}
						</p>

						<p
							className="text-black"
							dangerouslySetInnerHTML={{
								__html: props.content,
							}}
						/>
					</div>

					<p className="p-4 border-t border-grey-300 text-black text-sm font-bold">
						{/* eslint-disable-next-line react/jsx-no-literals -- using HTML Code for arrow */}
						{translate('agent.pages.widgets.blog.read_more')}
						&#10230;
					</p>
				</div>
			</div>
		);
	}

	if (props.isGated) {
		return body();
	}

	return (
		<a
			className="flex flex-col h-full"
			href={`https://blog.homekeepr.io/${props.slug}?tenant=${window.location.hostname}&sharedby=${props.agentSlug}`}
			key={props.slug}
			rel="noopener noreferrer"
			target="_blank"
		>
			{body()}
		</a>
	);
}
